// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screener-criteria-setting {
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 16px;

  box-sizing: border-box;
  padding: 16px 0px 32px 0px;

  &:not(:last-child) {
    border-bottom: 1px solid var(--border-line);
  }
}

.screener-criteria-setting-header {
  display: flex;
  justify-content: space-between;
}

.screener-criteria-setting-header-title {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-subheader);
}

.screener-criteria-setting-header-close {
  svg {
    width: 20px;
    height: 20px;

    path {
      fill: var(--accent-primary);
    }
  }
}

.screener-criteria-setting-slider-container {
  padding: 0 8px;
}

.screener-criteria-setting-input-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.screener-criteria-setting-input {
  box-sizing: border-box;
  padding: 8px 12px;
  width: 120px;
  height: 40px;
  background-color: #f9f9f9;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  stroke-color: #bfbfbf;
  stroke-width: 1px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-subheader);
  text-align: center;

  &:focus {
    outline: none;
  }
}

.screener-criteria-setting-input-label {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: var(--text-label);
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Screener/Criteria/CriteriaSetting/CriteriaSetting.css"],"names":[],"mappings":"AAAA;EACE,WAAW;;EAEX,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET,sBAAsB;EACtB,0BAA0B;;EAE1B;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;;IAEZ;MACE,2BAA2B;IAC7B;EACF;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;;EAElB;IACE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB","sourcesContent":[".screener-criteria-setting {\n  width: 100%;\n\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  box-sizing: border-box;\n  padding: 16px 0px 32px 0px;\n\n  &:not(:last-child) {\n    border-bottom: 1px solid var(--border-line);\n  }\n}\n\n.screener-criteria-setting-header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.screener-criteria-setting-header-title {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-subheader);\n}\n\n.screener-criteria-setting-header-close {\n  svg {\n    width: 20px;\n    height: 20px;\n\n    path {\n      fill: var(--accent-primary);\n    }\n  }\n}\n\n.screener-criteria-setting-slider-container {\n  padding: 0 8px;\n}\n\n.screener-criteria-setting-input-container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.screener-criteria-setting-input {\n  box-sizing: border-box;\n  padding: 8px 12px;\n  width: 120px;\n  height: 40px;\n  background-color: #f9f9f9;\n  border-radius: 4px;\n  border: 1px solid var(--border-primary);\n  stroke-color: #bfbfbf;\n  stroke-width: 1px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-subheader);\n  text-align: center;\n\n  &:focus {\n    outline: none;\n  }\n}\n\n.screener-criteria-setting-input-label {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--text-label);\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
